export const productionHostnames = [
  'nav.dasa.com.br',
  'nav-stg.dasa.com.br',
  'nav-beta.dasa.com.br',
]
